import type { XingletInterface } from '../../../jobs-xinglet';
import { JobsXingletWrapper } from '../../../jobs-xinglet';

import { RecommendationsSkeleton } from './recommendations-skeleton';

export type RecommendationsXinglet = XingletInterface;

export const Recommendations = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-recommendations-grid',
  <RecommendationsSkeleton />
);
